import alt from 'alt'
import { createActions } from 'alt-utils/lib/decorators'
import { ExtendedUserSource } from 'sources'
import { UserActions, Analytics } from 'common-frontend'

@createActions(alt)
export default class ExtendedUserActions {
  constructor() {
    this.generateActions(
      'setShopifyUserFetchFailed'
    )
  }

  getCurrent(token) {
    this.setShopifyUserFetchFailed(false)
    return ExtendedUserSource.fetchCurrent(token).then(resp => {
      UserActions.setExtendedUser(resp)
    }).catch(error => {
      this.setShopifyUserFetchFailed(true)
    })
  }

  update(settings) {
    return ExtendedUserSource.update(settings).then((resp) => {
      UserActions.setExtendedUser(resp)
    })
  }
}



// WEBPACK FOOTER //
// ./app/actions/ExtendedUserActions.js